import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKneader = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 170,
	height: 100,
	viewBox: "0 0 170.0 100.0",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 10,
		y: 0,
		width: 160,
		height: 100,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 50.0 L 30.0 50.0 L 60.0 30.0 L 110.0 70.0 L 150.0 50.0 L 170.0 50.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgKneader;
